import { useNavigate } from "@tanstack/react-router";
import { IconRotateClockwise } from "@tabler/icons-react";
import { Button, Card, Group, Stack, Text, ThemeIcon } from "@/components/ui";

/**
 * Card de la sidebar · solo aparece cuando la solicitud está en un
 * estado de rechazo (Reglas / Fiscal / Suspendida) · CTA a cargar
 * otro CFDI desde cero.
 */
export function ReintentarCard({ solicitudId }: { solicitudId: string }) {
  const navigate = useNavigate();
  return (
    <Card padding="md">
      <Stack gap="xs">
        <Group gap="xs">
          <ThemeIcon variant="filled" color="multiva" radius="md" size="md">
            <IconRotateClockwise size={14} />
          </ThemeIcon>
          <Text fw={600} size="sm">Reintenta</Text>
        </Group>
        <Text size="xs" c="dimmed">Sube otro CFDI para superar el rechazo.</Text>
        <Button
          size="xs"
          onClick={() =>
            navigate({
              to: "/solicitudes/$id/cargar-cfdi",
              params: { id: solicitudId },
              replace: true,
            })
          }
        >
          Cargar otro CFDI
        </Button>
      </Stack>
    </Card>
  );
}
